import { _removeWhitespace } from '@naturalcycles/js-lib';
import { addressFormats, countryByCode } from '../cnst/countries.js';
class AddressSharedUtil {
  /**
   * returns a localized address where each line is represented as a string in an array.
   *
   * e.g. string [
   *  'Mickey Mouse',
   *  'c/o Donald Duck',
   *  'Some Street 123',
   *  'Somecity, Someregion 12345',
   *  'United States'
   * ]
   *
   * the localized formats are defined by country code here:
   * ../cnst/countries/addressFormats
   *
   * @param address
   * @param appendCountry wheter or not to append country name in the end
   * @param filterEmpty
   */
  formatAddress(address, appendCountry = false, filterEmpty = true) {
    let format = address.countryCode && addressFormats[address.countryCode] || addressFormats['RoW'];
    let parts = [...addressFormats['RoW']];
    if (appendCountry) {
      format = [...format, 'countryCode'];
      parts = [...parts, 'countryCode'];
    }
    return format.map(line =>
    // eslint-disable-next-line unicorn/no-array-reduce
    parts.reduce((line, part) => {
      let v = address[part];
      if (appendCountry && part === 'countryCode' && v && typeof v !== 'boolean') {
        v = countryByCode[v];
      }
      if (part === 'name') {
        v = `${address.name1 ?? ''} ${address.name2 ?? ''}`;
      }
      return line.replace(part, v && 'string' === typeof v ? v : '');
    }, line)).filter(line => !filterEmpty || /[^,.\s]/.test(line));
  }
  /**
   * returns a localized address as a single string where each part is separated by ', '
   *
   * e.g. 'Mickey Mouse, c/o Donald Duck, Some Street 123, Somecity, Someregion 12345, United States'
   *
   * @param appendCountry wheter or not to append country name in the end
   * @param separator use a different separator than ', '
   */
  formatAddressSingleLine(address, appendCountry = false, separator = ', ', filterEmpty = true) {
    return this.formatAddress(address, appendCountry, filterEmpty).join(separator);
  }
  formatPostalCode(zip) {
    return _removeWhitespace(zip).toUpperCase();
  }
  getAddressName(address) {
    // Ignore typings for name2 as some names (pre name split) only entered their first name
    return `${address.name1} ${address.name2}`;
  }
}
export const addressSharedUtil = new AddressSharedUtil();